import * as yup from 'yup';

/**
 * Validation schema that blocks form submission when the selected time slot
 * has reached the user's consecutive booking limit.
 *
 * Always fails validation and is used as a signal to prevent booking submission
 * when the UserCapReached variant is detected via getGuestCapacityNoteForSlot.
 *
 * `consecutiveSlotBlockedSentinel` is not a real field on the interaction being
 * validated — it exists only so the always-failing `test` below has a key to
 * attach to.
 */
export const validateConsecutiveSlotBlocked = yup.object().shape({
  consecutiveSlotBlockedSentinel: yup.mixed().test(
    'consecutive-slot-blocked',
    'shared.content.feature.reservable.consecutiveSlot.maxReached',
    () => false
  ),
});
